module.exports = __webpack_public_path__ + "img/logo.968f1e3b.png";